import axios from 'axios';

// ✅ Full API base URL — change if your server address changes
// const API_BASE_URL = 'http://192.168.29.251:6003/api';
const API_BASE_URL = 'https://carapp-jayrajgroup.siancesoftware.tech/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use(
  (config) => {
    const customerToken = localStorage.getItem('accessToken');
    if (customerToken) config.headers['X-CUSTOMER-TOKEN'] = customerToken;
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (res) => res,
  (err) => {
    console.error('API Error:', err?.response?.data || err.message);
    return Promise.reject(err);
  }
);

export default api;